// Steps: Actions triggered for Calculator next button.
import { Dispatch } from 'redux';

import customHistory from '../../customHistory';
import { AppState } from '../../reducers';
import RoutePath from '../../util/mappings/routePath';
import { trackEvent, TrackingStep } from '../../util/piwik-utils';
import { updateCalculatorCache } from '../calculatorCache';
import { formCalculatorLoanInfo, FormTypeCalculatorLoanInfo } from '../forms';
import { AppActions } from '../types';

export const loanCalculatorNextEvent =
    (form: FormTypeCalculatorLoanInfo) => async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
        trackEvent(TrackingStep.Calculator);
        dispatch(formCalculatorLoanInfo(form));
        const { appType } = getState().context;

        if (appType === 'calculator') await updateCalculatorCache(dispatch, getState);
        else customHistory.push(RoutePath.application);
    };

export default { loanCalculatorNextEvent };
